// import { Link, NavLink } from "react-router-dom";
// import { useState } from "react";
// import { useAuth } from "../context/AuthContext";

// const linkBase = "px-3 py-2 rounded-md text-sm font-medium";
// const active = "text-white bg-brand.blue";


// export default function Navbar() {
//   const [open, setOpen] = useState(false);
//   const { user, logout } = useAuth();
//   const idle = "text-blue hover:text-white hover:bg-white/10";


//   return (
//     <header className="fixed inset-x-0 top-0 z-50 bg-brand.dark/80 backdrop-blur border-b border-white/10">


//       <nav className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
//         <div className="flex h-16 items-center justify-between">
//           <Link to="/" className="flex items-center gap-3">
//   <img
//     src="/logo1.png"   // or /logo.svg if that’s your file
//     alt="Main Street Car Wash logo"
//     className="h-12 w-auto object-contain"
//   />
// </Link>


//           <button className="md:hidden " onClick={() => setOpen(!open)} aria-label="menu">
//             ☰
//           </button>

//           <div className="hidden md:flex items-center gap-3">
//             <NavLink to="/" className={({isActive}) => `${linkBase} ${isActive?active:idle}`}>Home</NavLink>
//             <NavLink to="/services" className={({isActive}) => `${linkBase} ${isActive?active:idle}`}>Services</NavLink>
//             <NavLink to="/pricing" className={({isActive}) => `${linkBase} ${isActive?active:idle}`}>Pricing</NavLink>
//             <NavLink to="/contact" className={({isActive}) => `${linkBase} ${isActive?active:idle}`}>Contact</NavLink>

//             {/* IMPORTANT: No Login link visible to customers */}
//             {user && (
//               <>
//                 <NavLink to="/admin" className={({isActive}) => `${linkBase} ${isActive?active:idle}`}>Admin</NavLink>
//                 <button onClick={logout} className="ml-2 px-3 py-2 text-sm rounded-md bg-white/10 text-white hover:bg-white/20">
//                   Logout
//                 </button>
//               </>
//             )}
//           </div>
//         </div>

//         {open && (
//           <div className="md:hidden pb-4 space-y-2">
//             {["/","/services","/pricing","/contact"].map((p,i)=>(
//               <NavLink key={i} to={p} onClick={()=>setOpen(false)}
//                 className={({isActive}) => `block ${linkBase} ${isActive?active:idle}`}>{p === "/" ? "Home" : p.slice(1).charAt(0).toUpperCase() + p.slice(2)}
// </NavLink>
//             ))}
//             {/* Mobile: still no Login link */}
//             {user && (
//               <>
//                 <NavLink to="/admin" onClick={()=>setOpen(false)} className={`block ${linkBase} ${idle}`}>Admin</NavLink>
//                 <button onClick={()=>{logout(); setOpen(false);}} className="w-full text-left px-3 py-2 rounded-md bg-white/10 text-white">Logout</button>
//               </>
//             )}
//           </div>
//         )}
//       </nav>
//     </header>
//   );
// }



import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "../context/AuthContext";

const linkBase = "px-3 py-2 text-sm font-medium transition";
const idle = "text-slate-200 hover:text-white";
const active = "text-white border-b-2 border-cyan-400 pb-1";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { user, logout } = useAuth();

  return (
    <header className="fixed inset-x-0 top-0 z-50 bg-[#0b1220]/100 backdrop-blur border-b border-white/10">
      <nav className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3">
            <img
              src="/logo1.png"
              alt="Main Street Car Wash logo"
              className="h-14 w-auto object-contain"
            />
          </Link>

          {/* Mobile menu button */}
          <button
            className="md:hidden text-slate-200"
            onClick={() => setOpen(!open)}
            aria-label="menu"
          >
            ☰
          </button>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-6">
            {[
              { to: "/", label: "Home" },
              { to: "/services", label: "Services" },
              { to: "/pricing", label: "Pricing" },
              { to: "/contact", label: "Contact" },
            ].map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `${linkBase} ${isActive ? active : idle}`
                }
              >
                {item.label}
              </NavLink>
            ))}

            {/* Hidden login/admin unless signed in */}
            {user && (
              <>
                <NavLink
                  to="/admin"
                  className={({ isActive }) =>
                    `${linkBase} ${isActive ? active : idle}`
                  }
                >
                  Admin
                </NavLink>
                <button
                  onClick={logout}
                  className="px-3 py-2 text-sm rounded-md text-slate-200 hover:text-white"
                >
                  Logout
                </button>
              </>
            )}
          </div>
        </div>

        {/* Mobile Dropdown */}
        {open && (
          <div className="md:hidden bg-[#0a1220] border-t border-white/10 mt-2 space-y-2 rounded-b-xl py-4">
            {["/", "/services", "/pricing", "/contact"].map((p) => (
              <NavLink
                key={p}
                to={p}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `block ${linkBase} ${isActive ? active : idle}`
                }
              >
                {p === "/"
                  ? "Home"
                  : p.slice(1).charAt(0).toUpperCase() + p.slice(2)}
              </NavLink>
            ))}

            {user && (
              <>
                <NavLink
                  to="/admin"
                  onClick={() => setOpen(false)}
                  className={`block ${linkBase} ${idle}`}
                >
                  Admin
                </NavLink>

                <button
                  onClick={() => {
                    logout();
                    setOpen(false);
                  }}
                  className="block w-full text-left px-3 py-2 text-slate-200 hover:text-white"
                >
                  Logout
                </button>
              </>
            )}
          </div>
        )}
      </nav>
    </header>
  );
}
